const mocks = {
  getters: {
    getRoute: () => mocks.state.route,
    getMock: () => mocks.state.mock,
    getConfirmarRenaper: () => mocks.state.confirmarRenaper,
    getPaso1: () => mocks.state.paso1,
    getPaso2: () => mocks.state.paso2,
    getPaso3: () => mocks.state.paso3,
    getPaso4: () => mocks.state.paso4,
    getSucursal: () => mocks.state.sucursal,
    getDomicilio: () => tDomic => {
      if (tDomic === "10") {
        return mocks.state.domicilioAlternativo;
      }
      return mocks.state.domicilio;
    },
    getLocalidadesAgregadas: () => mocks.state.localidadesAgregadas,
    getCBU: () => mocks.state.graciasCA.cbu,
    getCBUPaq: () => mocks.state.gracias.cbu,
    getCBUcontratacion: () => mocks.state.respuestaContratacion.cbu,
    getTCode: () => mocks.state.tcode,
    getStatusSocialNet: () => mocks.state.socialNet.status,
    getConsulta: () => mocks.state.consulta,
    getForzarDNE: () => mocks.state.forzarDNE,
    getPaquetesBeneficios: () => mocks.state.paquetesBeneficios,
    getOferta: () => mocks.state.dataOferta.oferta,
    getDataOferta: () => mocks.state.dataOferta,
    getDataQuery: () => mocks.state.dataQuery,
    getValidacionDomicilio: () => {},
    getValidacionDomicilioOtro: () => {},
    getSearchEncontesa: () => mocks.state.searchEncontesa,
    getDatosCaSuelta: () => mocks.state.datosCaSuelta.datos,
    getDatosCGU: () => mocks.state.datosCGU.datos,
    getDatosCaEmprendedores: () => mocks.state.getDatosCaEmprendedores.datos,
    getEnvioSms: () => mocks.state.envioSms,
    getDatosPersonales: () => mocks.state.datosPersonales,
    getAdobeTargetExperience: () => {},
    getCelularNormalizado: () => mocks.state.consulta.celular.normalizado,
    getConfirmacionData: () => ({
      cliente: {
        emailContacto: mocks.state.consulta.email,
        telContacto: {
          caracteristica: mocks.state.consulta.celular.numero.slice(0, 4),
          nro: mocks.state.consulta.celular.numero.slice(4, 8),
          interno: "",
          area: mocks.state.consulta.celular.area
        },
        lugarNacimiento: mocks.state.paso1.lugarNacimiento,
        cuil: mocks.state.paso1.cuil,
        estadoCivil: mocks.state.paso1.estadoCivil,
        conyuge: {
          tipoDocumento: mocks.state.paso1.conyuge.tipoDoc,
          numeroDocumento: mocks.state.paso1.conyuge.numeroDoc,
          apellido: mocks.state.paso1.conyuge.apellido,
          nombre: mocks.state.paso1.conyuge.nombre,
          nacionalidad: ""
        },
        domicilio: {
          calle: mocks.state.paso1.domicilioParticular.calle,
          numero: mocks.state.paso1.domicilioParticular.numero,
          piso: mocks.state.paso1.domicilioParticular.piso,
          depto: mocks.state.paso1.domicilioParticular.dpto,
          codigoPostal: mocks.state.paso1.domicilioParticular.codigoPostal,
          localidad: mocks.state.paso1.domicilioParticular.localidad,
          codProvincia: "CAPITAL FEDERAL",
          referencia: ""
        },

        domAlternativo: {
          calle:
            mocks.state.paso4.selectDomicilio === "otro"
              ? mocks.state.paso4.otroDomicilio.calle
              : mocks.state.paso1.domicilioParticular.calle,
          numero:
            mocks.state.paso4.selectDomicilio === "otro"
              ? mocks.state.paso4.otroDomicilio.numero
              : mocks.state.paso1.domicilioParticular.numero,
          piso:
            mocks.state.paso4.selectDomicilio === "otro"
              ? mocks.state.paso4.otroDomicilio.piso
              : mocks.state.paso1.domicilioParticular.piso,
          depto:
            mocks.state.paso4.selectDomicilio === "otro"
              ? mocks.state.paso4.otroDomicilio.dpto
              : mocks.state.paso1.domicilioParticular.dpto,
          codigoPostal:
            mocks.state.paso4.selectDomicilio === "otro"
              ? mocks.state.paso4.otroDomicilio.codigoPostal
              : mocks.state.paso1.domicilioParticular.codigoPostal,
          localidad:
            mocks.state.paso4.selectDomicilio === "otro"
              ? mocks.state.paso4.otroDomicilio.localidad
              : mocks.state.paso1.domicilioParticular.localidad,
          codProvincia:
            mocks.state.paso4.selectDomicilio === "otro"
              ? "CAPITAL FEDERAL"
              : "CAPITAL FEDERAL",
          referencia: ""
        },
        situacionLaboral: "En rel. de dependencia",
        tipoActividad: "OTROS SERVICIOS",
        tipoOcupacion: "ADMINISTRATIVO",
        tipoPagoTarjeta: "1",
        marcaPEP: !!Number(mocks.state.paso3.pep),
        marcaSujetoObligado: !!Number(mocks.state.paso3.sujetoObligado),
        constanciaSujetoObligado: false,
        actividadSujetoObligado: mocks.state.paso3.actividadSujetoObligado,
        eResumen: mocks.state.paso4.resumenDigital,
        eResumenEmail: mocks.state.paso4.email,
        deviceId: mocks.state.deviceId,
        deviceIdTimestamp: mocks.state.deviceIdTimestamp
      },
      producto: {
        solicitudSucursal: mocks.state.paso4.sucursal
          ? (mocks.state.paso4.sucursal + "").padStart(4, "0")
          : "0999"
      },
      randomKey: mocks.state.oferta.randomkey
    }),
    getCuenta: () => mocks.state.cuenta,
    getDeviceId: () => mocks.state.deviceId,
    getDeviceIdTimestamp: () => mocks.state.deviceIdTimestamp,
    getKeyLoginVeridas: () => mocks.state.dataVeridas.key,
    getConfiguracion: () => mocks.state.configuracion,
    getIdentidad: () => mocks.state.identidad,
    getInformacionAdicional: () => mocks.state.informacionAdicional,
    getDatosContacto: () => mocks.state.datosContacto,
    getContrato: () => mocks.state.contrato,
    getResultVeridas: () => mocks.state.getResultVeridas,
    getConfirmacionDataVeridas: () => ({}),
    getContractsPdf: () => mocks.state.dataVeridas.contracts,
    getNumeroTramite: () => mocks.state.configuracion.numeroTramite,
    getRandomKey: () => mocks.state.dataOferta.randomkey,
    getDeviceUdid: () => mocks.state.celular.deviceUdid,
    getLocalidadesAgregadasByProv: () => {},
    getTieneCoordenadas: () => true,
    getSucursales: () => mocks.state.sucursales,
    getNumeroCliente: () => mocks.state.oferta.numeroCliente,
    getVeridasId: () => mocks.state.DVSIframeData.id
  },
  state: {
    userIdTokenizado: null,
    tcode: "mockTCode",
    isLoading: false,
    adobeTargetExperience: null,
    trackClickElement: null,
    trackOnClickStart: null,
    forzarDNE: {},
    socialNet: {
      status: "NONE"
    },
    notificationToast: {
      // [info, success, alert]
      type: "type",
      message: "message"
    },
    searchEncontesa: {
      searchType: "",
      list: []
    },
    confirmarRenaper: {
      expediente: "",
      yaValido: false
    },
    mock: null,
    openedModal: false,
    consulta: {
      nombre: "nombreConsultaTest",
      apellido: "apellidoConsultaTest",
      tipoDoc: "00",
      numeroDoc: "99888777",
      nacionalidad: "80",
      sexo: "M",
      email: "",
      tipoResidencia: "",
      fechaNacimiento: "01/01/0476",
      celular: {
        area: "11",
        numero: "28756563",
        normalizado: {
          area: "11",
          caracteristica: "3815",
          nro: "3838",
          interno: "",
          valido: true
        }
      },
      captcha: ""
    },
    dataOferta: {
      oferta: {
        valid: false,
        numeroCliente: "1234567890"
      },
      randomkey: "randomKey"
    },
    dataQuery: {
      sucursal: "0001"
    },
    paquetesBeneficios: {
      caracteristicas: {
        tipoPaquete: "04"
      },
      gracias: {
        items: ["", "Hola"]
      },
      incluye: {
        tarjetas: [""]
      },
      beneficios: {
        tiutlo: ""
      }
    },
    paso1: {
      estadoCivil: "5",
      conyuge: {
        nombre: "",
        apellido: "",
        tipoDoc: "00",
        numeroDoc: ""
      },
      lugarNacimiento: "",
      domicilioParticular: {
        calle: "",
        numero: "",
        piso: "",
        dpto: "",
        codigoPostal: "",
        localidad: "",
        codProvincia: "01",
        valido: true
      },
      searchEncontesa: false
    },
    paso2: {
      situacionLaboral: "001",
      actividad: "47",
      ocupacion: "07",
      tipoCuil: "49",
      cuil: ""
    },
    paso3: {
      pep: "",
      sujetoObligado: "",
      fatca: "",
      actividadSujetoObligado: ""
    },
    paso4: {
      email: "",
      resumenDigital: "mockResumenDigital",
      sucursal: "",
      selectDomicilio: "particular",
      domicilioParticular: {
        calle: "",
        numero: "",
        piso: "",
        dpto: "",
        codigoPostal: "",
        localidad: "",
        codProvincia: "01",
        valido: null
      },
      otroDomicilio: {
        calle: "",
        numero: "",
        piso: "",
        dpto: "",
        codigoPostal: "",
        localidad: "",
        codProvincia: "01",
        valido: null
      },
      searchEncontesa: false
    },
    datosCaSuelta: {
      key: "",
      datos: {
        nombre: "nombreCaSuelta",
        apellido: "apellidoCaSuelta",
        tipoDoc: "00",
        numeroDoc: "11222333",
        nacionalidad: "80",
        genero: "F",
        fechaNacimiento: "11/11/1111",
        email: "",
        telefono: "1151112222",
        circuito: "caSuelta"
      }
    },
    datosCGU: {
      key: "",
      datos: {
        nombre: "nombreCGU",
        apellido: "apellidoCGU",
        tipoDoc: "00",
        numeroDoc: "11222333",
        nacionalidad: "80",
        genero: "F",
        fechaNacimiento: "11/11/1111",
        email: "",
        telefono: "1151112222",
        circuito: "cgu"
      }
    },
    datosCaEmprendedores: {
      key: "",
      datos: {
        nombre: "nombreCaEmprendedores",
        apellido: "apellidoCaEmprendedores",
        tipoDoc: "00",
        numeroDoc: "11222333",
        nacionalidad: "80",
        genero: "F",
        fechaNacimiento: "11/11/1111",
        email: "",
        telefono: "1151112222",
        circuito: "caEmprendedores"
      }
    },
    domicilio: {
      codIden: "",
      claIden: "",
      desDomi: "",
      tDomic: "06",
      localid: "CAPITAL FEDERAL",
      codPost: "",
      codProv: "01",
      codPais: "080",
      codNuev: "",
      valNuev: "",
      codModi: "",
      valModi: "",
      tDoModi: "",
      numModi: "",
      accion: "",
      indBloq: "",
      opcion: "",
      coorX: "",
      coorY: "",
      titul: "",
      indDuda: "",
      indOrig: "WEB",
      indPref: "",
      lote: "",
      manzana: "",
      casa: "",
      sector: "",
      parcela: "",
      calle1: "",
      calle2: "",
      tipImb: "",
      dudas: [],
      inusual: false,
      alternativo: false,
      rehacer: false,
      preexistente: false,
      validarPreexistente: true
    },
    domicilioAlternativo: {
      codIden: "",
      claIden: "",
      desDomi: "",
      tDomic: "",
      localid: "CAPITAL FEDERAL",
      codPost: "",
      codProv: "01",
      codPais: "080",
      codNuev: "",
      valNuev: "",
      codModi: "",
      valModi: "",
      tDoModi: "",
      numModi: "",
      accion: "",
      indBloq: "",
      opcion: "",
      coorX: "",
      coorY: "",
      titul: "",
      indDuda: "",
      indOrig: "WEB",
      indPref: "",
      lote: "",
      manzana: "",
      casa: "",
      sector: "",
      parcela: "",
      calle1: "",
      calle2: "",
      tipImb: "",
      dudas: [],
      inusual: false,
      alternativo: false,
      rehacer: false,
      preexistente: false
    },
    datosLaborales: {
      situacionLaboral: "001",
      actividad: "47",
      ocupacion: "07",
      tipoCuil: "49",
      cuil: ""
    },
    informacionAdicional: {
      pep: "0",
      sujetoObligado: "0",
      actividadSujetoObligado: "",
      fatca: "0"
    },
    localidadesAgregadas: {
      "01": [
        {
          label: "CABA",
          value: "CABA"
        }
      ]
    },
    envioSms: {
      status: "",
      sms: {
        area: "",
        numero: "",
        mensaje: ""
      }
    },
    sucursal: {
      sucursal: "1",
      cuil: "20-00000000-0"
    },
    graciasCA: {
      cbu: ""
    },
    gracias: {
      cbu: ""
    },
    key: "",
    route: {
      name: "mensajeErrorSolicitudCuenta"
    },
    identidad: {
      isDigital: false,
      isPresencial: null,
      isPresencialVoluntario: false
    },
    configuracion: {
      selectDomicilio: "particular",
      sucursal: "",
      domicilioParticular: {
        calle: "",
        numero: "",
        piso: "",
        dpto: "",
        codigoPostal: "",
        localidad: "",
        provincia: "01"
      },
      otroDomicilio: {
        calle: "",
        numero: "",
        piso: "",
        dpto: "",
        codigoPostal: "",
        localidad: "",
        provincia: "01"
      },
      fecha: "",
      hora: "de 9 a 12 hs.",
      resumenDigital: true,
      resumenDigitalEmail: "",
      numeroTramite: "123"
    },
    datosPersonales: {
      estadoCivil: "5",
      conyuge: {
        nombre: "",
        apellido: "",
        tipoDoc: "00",
        numeroDoc: ""
      },
      lugarNacimiento: "",
      domicilioParticular: {
        calle: "",
        numero: "",
        piso: "",
        dpto: "",
        codigoPostal: "",
        localidad: "",
        provincia: "01",
        valido: null
      }
    },
    deviceId: "mocksDeviceId",
    deviceIdTimestamp: "mocksDeviceIdTimestamp",
    respuestaContratacion: {
      cbu: ""
    },
    contrato: {
      firmaContrato: false
    },
    datosContacto: {
      telWebP: ""
    },
    getResultVeridas: {},
    cuenta: false,
    dataVeridas: {
      key: "",
      response: {
        isValid: null
      },
      contracts: [],
      thanksVeridas: false
    },
    ga4: {
      eventParams: {
        level1: "",
        level2: ""
      }
    },
    sdk: {
      preload: false,
      isVisible: false,
      iframe: false
    },
    DVSIframeData: { id: "dvs-id" },
    contratosFirmados: {},
    celular: {
      deviceUdid: "",
      otp: "",
      otpValid: null,
      error: false
    },
    dataAuthASO: {
      token: "mocked-token",
      tsecExpiry: 123456789
    },
    oferta: {
      numeroCliente: "1234567890",
      randomkey: "randomKey"
    },
    sucursales: [
      {
        descripcion: "sucursal1",
        id: "10",
        address: {
          city: "La Plata",
          addressName: "city"
        },
        distance: ""
      },
      {
        descripcion: "sucursal1",
        id: "10",
        address: {
          city: "La Plata",
          addressName: "city"
        },
        distance: ""
      }
    ]
  },

  dispatch: jest.fn(),
  watch: jest.fn(),
  commit: jest.fn(),
  subscribe: jest.fn()
};

export default mocks;
